import React from 'react';

export default function (email) {
  return <a href={`mailto:${email}`} target='_top'>{email}</a>;
}



// WEBPACK FOOTER //
// ./shared/lib/emailLink.js